import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild,} from "@angular/core";
import {
  AutocompleteComponent,
  AutocompleteLoadingModeType,
  IAutocompleteSchema,
  ToastService
} from "maps-angular-components";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {GrupoCarteira} from "../../../grupo-carteira/grupo-carteira";
import {GrupoCarteiraService} from "../../../grupo-carteira/grupo-carteira.service";
import {AssociacaoGrupoCarteiraService} from "../../associacao-grupo-carteira.service";

@Component({
  selector: "selecao-grupo-carteira",
  templateUrl: "./selecao-grupo-carteira.component.html",
  styleUrls: ["./selecao-grupo-carteira.component.scss"],
})
export class SelecaoGrupoCarteiraComponent implements OnInit {
  @ViewChild("selecaoGrupoCarteiraAutocomplete", {static: false}) selecaoGruposCarteiraGrupo: AutocompleteComponent<GrupoCarteira>;
  @ViewChild('formDirective') formDirective;

  @Input() form: FormGroup;

  @Output() onGrupoCarteiraChange: EventEmitter<GrupoCarteira> = new EventEmitter<GrupoCarteira>();

  public grupoCarteiraSchema: IAutocompleteSchema<GrupoCarteira>;
  gruposCarteiras: GrupoCarteira[] = [];
  page: any = 1;
  private grupoCarteiraHolder: GrupoCarteira;

  constructor(
    public associacaoGrupoCarteiraService: AssociacaoGrupoCarteiraService,
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly formBuilder: FormBuilder,
    public grupoCarteiraService: GrupoCarteiraService,
  ) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      grupoCarteira: new FormControl(),
    });
    this.grupoCarteiraSchema = {
      service: this.grupoCarteiraService,
      label: "Grupo de carteira",
      placeholder: "Grupo de carteira selecionada",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "",
      formGroup: this.form,
      required: true,
      formControlName: "grupoCarteira",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
  }

  receiverPage(e: any) {
    this.page = e;
  }

  clear() {
    this.selecaoGruposCarteiraGrupo.reset();
    this.gruposCarteiras = [];
    this.form.reset();
    this.formDirective.resetForm();
  }

  grupoCarteiraSelecionada(grupoCarteira: GrupoCarteira) {
    this.onGrupoCarteiraChange.emit(grupoCarteira);
  }
}
